const CNAE_DIGIT_COUNT = 7

export const formatCnae = (rawValue: string): string => {
  const digits = rawValue.replace(/\D/g, '').slice(0, CNAE_DIGIT_COUNT)

  const [group, cls, subclass] = [digits.slice(0, 4), digits.slice(4, 5), digits.slice(5, 7)]

  return [group, cls && `-${cls}`, subclass && `/${subclass}`].filter(Boolean).join('')
}
